import './style.css';
import { EventChannel } from '@syllepsis/adapter';
import debounce from 'lodash.debounce';
import { NODE_NAME } from '../../const';
import { closestTable } from '../../utils';
var DEFAULT_TIP = 'rows & columns'; // '选择表格行列数'
var DEFAULT_CONFIG = {
    row: 7,
    column: 7,
    cellWith: 16,
    margin: 2,
    defaultColor: '#F2F2F2',
    activeColor: '#B2D1FF',
    trigger: 'hover',
};
var Cell = function (color, width, margin) {
    if (color === void 0) { color = '#b2d1ff'; }
    if (width === void 0) { width = 16; }
    var blockWidth = width + margin * 2;
    return "'data:image/svg+xml;utf8," + encodeURIComponent("<svg xmlns=\"http://www.w3.org/2000/svg\" x=\"" + margin + "\" y=\"" + margin + "\" viewBox=\"0 0 " + blockWidth + " " + blockWidth + "\" width=\"" + blockWidth + "\" height=\"" + blockWidth + "\"><rect width=\"" + width + "\" height=\"" + width + "\" fill=\"" + color + "\"/></svg>") + "'";
};
var TableButton = /** @class */ (function () {
    function TableButton(editor, _btn, onSelected, config) {
        var _this = this;
        // wrapper DOM of menu
        this.$wrapper = document.createElement('div');
        // tip DOM for row & columns
        this.$tip = document.createElement('div');
        this.$size = document.createElement('div');
        this.$cellList = document.createElement('div');
        // background color dom
        this.$back = document.createElement('div');
        // highlight color dom
        this.$cover = document.createElement('div');
        this._visible = false;
        // not that the `blockWidth` contains margin
        this.blockWidth = 0;
        // the selected area
        this._selectedArea = { row: 0, column: 0 };
        this.onMouseMove = function (e) {
            if (!_this.visible)
                return;
            var offsetX = e.offsetX, offsetY = e.offsetY;
            _this.selectedArea = {
                row: Math.ceil(offsetY / _this.blockWidth),
                column: Math.ceil(offsetX / _this.blockWidth),
            };
        };
        this.onAreaClick = function (e) {
            _this.onSelected(_this.selectedArea);
            _this.closeMenu();
            _this.menuConfig.trigger === 'click' && e.stopPropagation();
        };
        this.closeMenu = debounce(function () {
            _this.hideMenu();
            _this.selectedArea = { row: 0, column: 0 };
        }, 100);
        this.onButtonMouseLeave = function (e) {
            var related = e.relatedTarget;
            if (!_this.$wrapper.contains(related)) {
                _this.closeMenu();
            }
        };
        this.showMenu = function (e) {
            if (_this.triggerEvent === 'click' && _this.isInList)
                e.stopPropagation();
            if (closestTable(_this.editor.view.state.selection.$from))
                return;
            _this.editor.focus();
            _this.visible = true;
        };
        this.hideMenu = function () {
            _this.visible = false;
        };
        this.setTip = function () {
            var locale = _this.editor.configurator.getLocaleValue(NODE_NAME.TABLE) || {};
            _this.$tip.innerText = locale.menuTip || DEFAULT_TIP;
        };
        this.editor = editor;
        var btn = _btn;
        if (typeof btn === 'string') {
            btn = document.querySelector(btn);
        }
        this.onSelected = onSelected;
        this.menuConfig = Object.assign({}, DEFAULT_CONFIG, config);
        this.blockWidth = this.menuConfig.cellWith + this.menuConfig.margin * 2;
        this.$button = btn;
        if (!this.$button)
            return;
        this.$button.classList.add('table-menu-button-before');
        this.renderMenu();
        this.bindEvent();
    }
    Object.defineProperty(TableButton.prototype, "triggerEvent", {
        get: function () {
            return this.menuConfig.trigger === 'hover' ? 'mouseenter' : 'click';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TableButton.prototype, "isInList", {
        get: function () {
            return this.$button.className.includes('horizon');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TableButton.prototype, "visible", {
        get: function () {
            return this._visible;
        },
        set: function (vis) {
            this._visible = vis;
            if (vis) {
                var style = 'position: absolute;display: block;z-index: 99;';
                // vertical button
                if (this.isInList) {
                    var top_1 = this.$button.offsetHeight;
                    style += "transform: translate(-105%, -" + top_1 + "px);";
                }
                else {
                    var $toolbar = this.$button.parentElement;
                    if ($toolbar) {
                        var left = 0;
                        var domWidth = this.$wrapper.clientWidth;
                        var mountRect = this.$button.getBoundingClientRect();
                        var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
                        if (mountRect.left < 0) {
                            left = -mountRect.left;
                        }
                        else if (mountRect.left + domWidth > viewportWidth) {
                            left = -(domWidth - (viewportWidth - mountRect.left));
                        }
                        left && (style += "left: " + left + "px;");
                    }
                }
                this.$wrapper.setAttribute('style', style);
            }
            else {
                this.$wrapper.setAttribute('style', 'position: absolute; visibility: hidden; left: -99999px;');
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TableButton.prototype, "selectedArea", {
        get: function () {
            return this._selectedArea;
        },
        set: function (_a) {
            var row = _a.row, column = _a.column;
            this.$cover.style.height = row * this.blockWidth + "px";
            this.$cover.style.width = column * this.blockWidth + "px";
            if (row && column)
                this.$size.innerText = row + " x " + column;
            else
                this.$size.innerText = '';
            this._selectedArea = { row: row, column: column };
        },
        enumerable: false,
        configurable: true
    });
    TableButton.prototype.renderMenu = function () {
        var _a = this.menuConfig, cellWith = _a.cellWith, defaultColor = _a.defaultColor, activeColor = _a.activeColor, row = _a.row, column = _a.column, margin = _a.margin;
        this.$wrapper.classList.add('syl-table-menu-wrapper');
        var $tipWrapper = document.createElement('div');
        $tipWrapper.classList.add('syl-table-menu-tip-wrapper');
        this.$wrapper.setAttribute('style', 'position: absolute;visibility: hidden;');
        this.$tip.classList.add('syl-table-menu-tip');
        this.$size.classList.add('syl-table-menu-size-tip');
        this.setTip();
        $tipWrapper.appendChild(this.$tip);
        $tipWrapper.appendChild(this.$size);
        this.$wrapper.appendChild($tipWrapper);
        this.$cellList.classList.add('syl-table-menu-list');
        this.$cellList.setAttribute('style', "width: " + column * this.blockWidth + "px;height: " + row * this.blockWidth + "px;");
        this.$back.classList.add('syl-table-menu-back');
        this.$cover.classList.add('syl-table-menu-cover');
        this.$back.setAttribute('style', "width: 100%;height: 100%;background-image: url(" + Cell(defaultColor, cellWith, margin) + ");");
        this.$cover.setAttribute('style', "position: absolute;top: 0;background-image: url(" + Cell(activeColor, cellWith, margin) + ");");
        this.$cellList.appendChild(this.$back);
        this.$cellList.appendChild(this.$cover);
        this.$wrapper.appendChild(this.$cellList);
        this.$button.appendChild(this.$wrapper);
    };
    TableButton.prototype.unMount = function () {
        this.unBindEvent();
        this.$wrapper.remove();
    };
    TableButton.prototype.bindEvent = function () {
        if (!this.$button)
            return;
        this.$button.addEventListener(this.triggerEvent, this.showMenu);
        this.$button.addEventListener('mouseleave', this.onButtonMouseLeave);
        this.$cellList.addEventListener('click', this.onAreaClick);
        this.$cellList.addEventListener('mousemove', this.onMouseMove);
        this.editor.on(EventChannel.LocalEvent.LOCALE_CHANGE, this.setTip);
    };
    TableButton.prototype.unBindEvent = function () {
        if (this.$button) {
            this.$button.removeEventListener(this.triggerEvent, this.showMenu);
            this.$button.removeEventListener('mouseleave', this.onButtonMouseLeave);
        }
        if (this.$cellList) {
            this.$cellList.removeEventListener('click', this.onAreaClick);
            this.$cellList.removeEventListener('mousemove', this.onMouseMove);
        }
        this.editor.off(EventChannel.LocalEvent.LOCALE_CHANGE, this.setTip);
    };
    return TableButton;
}());
export { DEFAULT_CONFIG as BUTTON_DEFAULT_CONFIG, TableButton };
//# sourceMappingURL=index.js.map